import { FC } from 'react';

import { Modal, ModalOverlay } from '@bonusly/design-system';

import { MeetingDTO } from '../../lib/entities/meeting';
import { UserDTO } from '../../lib/entities/user';
import { RescheduleModalContent } from './reschedule-modal-content';

interface RescheduleModalProps {
	meeting: MeetingDTO;
	isOpen: boolean;
	onClose: VoidFunction;
	onOpenCancelModal: VoidFunction;
	guest: UserDTO;
}

export const RescheduleModal: FC<RescheduleModalProps> = ({ isOpen, onClose, meeting, onOpenCancelModal, ...rest }) => {
	if (meeting === null) {
		return null;
	}

	return (
		<Modal autoFocus={false} isOpen={isOpen} onClose={onClose} scrollBehavior="outside" size="md" isCentered>
			<ModalOverlay />
			<RescheduleModalContent meetingId={meeting.id} onClose={onClose} onOpenCancelModal={onOpenCancelModal} {...rest} />
		</Modal>
	);
};
